import Flickity from 'flickity';
import { module } from 'modujs';
import { gsap } from '../gsap'

import { padNumber } from '../utils/html'

export default class BrandList extends module {

    static get settings() {
        return {
            VISIBLE_CLASS: 'is-visible'
        }
    }

    constructor(m) {
        super(m);

        // DOM Elements
        this.$container = this.$('container')[0]
        this.$shoe = this.$('shoe')[0]
        this.$leaveLeft = this.$('leave-left')[0]
        this.$leaveRight = this.$('leave-right')[0]
        // this.$counter = this.$('counter')[0]
        // this.$counterValue = this.$('counter-value')[0]
        this.$list = this.$('list')[0]
        this.$items = Array.from(this.$('item'))
        this.$logo = this.$('logo')[0]
        this.$logoInner = this.$logo.children[0]

        // Items count
        this.totalItems = this.$items.length
    }

    init() {

        this.set()

        window.addEventListener('resize', this.onResize = () => this.set())
    }

    updateItem(newIndex, oldIndex) {

        if(newIndex >= 0 && newIndex < this.totalItems) {
            this.$items[newIndex].classList.add(BrandList.settings.VISIBLE_CLASS)
            // this.updateCounter(newIndex + 1)
        }

        if(oldIndex >= 0 && oldIndex < this.totalItems) {
            this.$items[oldIndex].classList.remove(BrandList.settings.VISIBLE_CLASS)
        }
    }

    // updateCounter(number=1) {
    //     this.$counterValue.innerHTML = padNumber(number)
    // }

    set() {

        if(this.flkty) {
            this.flkty.destroy()
        }

        if(this.tl) {
            this.tl.scrollTrigger.kill(true)
            this.tl.kill(true)
        }

        // Desktop animation
        if (window.innerWidth >= 700) {

            this.flkty = false

            let scrollDirection = 0
            const itemProxy = {
                value: -1
            }

            this.tl = gsap.timeline({
                scrollTrigger: {
                    trigger: this.el,
                    start: 'top center',
                    end: `bottom+=${this.totalItems * 250 + 200}% top`,
                    pin: true,
                    anticipatePin: 1,
                    scrub: true,
                    onUpdate: ({direction}) => {
                        scrollDirection = direction
                    }
                },
                defaults: {
                    ease: 'none',
                    duration: 2,
                },
            })

            let oldVal = itemProxy.value
            this.tl
                .fromTo(this.$container, {
                        y: 0
                    }, {
                        y: '-50vh',
                        ease: 'power2'
                    },
                'in')
                .from(this.$leaveLeft, {
                    xPercent: -30,
                }, 'in')
                .from(this.$leaveRight, {
                    xPercent: 50,
                }, 'in')
                // .to(this.$counter, {
                //     opacity: 1,
                //     duration: 1
                // }, '-=100%')
                .fromTo(itemProxy,
                    {
                        value: -0.01,
                    }, {
                        value: this.totalItems - 0.01,
                        duration: 2.5 * this.totalItems,
                        onUpdate: () => {
                            const val = Math.floor(itemProxy.value)

                            if(val !== oldVal) {
                                this.updateItem(val, oldVal)
                                oldVal = val
                            }
                        }
                    },
                'items')
                .fromTo(this.$leaveLeft,
                    {
                        yPercent: 200
                    },
                    {
                        yPercent: -200,
                        duration: 2 * this.totalItems,
                    },
                'items')
                .fromTo(this.$leaveRight,
                    {
                        yPercent: -200
                    },
                    {
                        yPercent: 0,
                        duration: 2 * this.totalItems,
                    },
                'items')
                .fromTo(this.$shoe,
                    {
                        yPercent: 0,
                    },
                    {
                        yPercent: 50,
                        duration: 2 * this.totalItems + 2,
                    },
                'items')
                // .fromTo(this.$counter,
                //     {
                //         '--brand-list-counter-translate': 0,
                //     },
                //     {
                //         '--brand-list-counter-translate': 1,
                //         duration: 2 * this.totalItems,
                //     },
                // 'items')
                .add(() => {
                    this.updateItem(this.totalItems, this.totalItems - 1)
                    oldVal = this.totalItems
                }, 'clear-=2')

                // .to(this.$counter, {
                //     opacity: 0,
                //     duration: 1
                // }, '-=100%')
                .to(this.$leaveLeft, {
                    xPercent: -30,
                }, 'clear-=2')
                .to(this.$leaveRight, {
                    xPercent: 50,
                }, 'clear-=2')
                .to(this.$container, {
                    y: '-150vh',
                    duration: 6,
                }, 'out')
                .to(this.$logo,  {
                    yPercent: 100,
                    duration: 6,
                }, 'out')
                .fromTo(this.$logoInner,
                    {
                        x: '100vw',
                    },
                    {
                        x: '-100%',
                        duration: 6,
                    },
                'out')


        } else {
            this.tl = false

            // Mobile Slider
            this.flkty = new Flickity(this.$list, {
                autoPlay: 4000,
                draggable: false,
                prevNextButtons: false,
                friction: 0.8,
                selectedAttraction: 0.1,
                wrapAround: true,
            })

            // this.flkty.on('select', i => this.updateCounter(i + 1))
        }
    }

    destroy() {
        if(this.flkty) {
            this.flkty.destroy()
        }

        if(this.tl) {
            this.tl.kill()
        }
    }
}
